<template>
	<div>
		<BaseAccordionController
			:accordion_header="getStateWithParam('label_bus_report_card')"
			:expand_accondion="true"
		>
			<template v-slot:component>
				<h4 class="mx-3 mb-3">
					{{ getStateWithParam("bus_report_header") }}
				</h4>

				<p class="mx-3">
					{{ getStateWithParam("bus_report_content") }}
				</p>
				<div class="d-flex justify-center">
					<v-btn
						@click="openReportWeb()"
						style="
							background-color: #e60000;

							margin: 30px 15px 60px 15px;
							padding: 25px;
							border-radius: 5px;
						"
					>
						<span style="color: #ffff">
							{{ getStateWithParam("label_bus_report_card") }}
						</span>
					</v-btn>
				</div>
			</template>
		</BaseAccordionController>
	</div>
</template>

<script>
import native_capacitor from "@/config/js_helper/native_capacitor";
export default {
	name: "raportBus",
	props: {},
	components: {},
	data() {
		return {
			dataloaded: false,
		};
	},
	computed: {},
	watch: {},
	created() {
		this.loadPage();
	},
	methods: {
		loadPage() {
			this.dataloaded = true;
			this.$store.state.active_loader = false;
		},

		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		openReportWeb() {
			const reportURL = `https://urbani.tirana.al/`;
			native_capacitor.openUrl(reportURL);
		},
	},
};
</script>

<style scoped lang="scss" src="./raportBus.scss"></style>
